import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';

const styles = theme => ({
  reviewProposalsContentContainer: {
    marginTop: '50px'
  },
  noData: {
    marginTop: '150px',
    height: '150px'
  }
});

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {};
};

export default compose(
  withRouter,
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps(({ profile, auth }) => ({
    profile,
    auth
  })),
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/campaign/review-campaigns/AllProposals.enhancer.js